/**
 * 本文件代码存储的是报价时不同品质对应的key
 */

/* 品牌代码、品牌名称、品牌简称，这三个目前只有品牌件的品质会有。记录时间：2025年1月20日 15点13分 */

/* 各品质报价小计的key, 这个暂时没用到。记录时间：2025年3月13日 15点58分 */
export const QUOTE_SUBTOTAL_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'ORIGIN_FACTORY_ORIGIN_PACKAGE__subtotalKey',
  ORIGIN_FACTORY_EASY_PACKAGE:'ORIGIN_FACTORY_EASY_PACKAGE__subtotalKey',
  OE:'OE__subtotalKey',
  BRAND:'BRAND__subtotalKey',
  CAR_DISASSEMBLY_PART:'CAR_DISASSEMBLY_PART__subtotalKey',
  DEPUTY_FACTORY:'DEPUTY_FACTORY__subtotalKey',
  REMANUFACTURED_PARTS: 'REMANUFACTURED_PARTS__subtotalKey',
};

/* 报价的不同品质的品牌代码 */
export const QUOTE_BRAND_CODE_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'',
  ORIGIN_FACTORY_EASY_PACKAGE:'',
  OE:'pt_brand_code',
  BRAND:'pp_brand_code',
  CAR_DISASSEMBLY_PART:'',
  DEPUTY_FACTORY:'',
  REMANUFACTURED_PARTS: '',
}

/* 报价的不同品质的品牌名称 */
export const QUOTE_BRAND_NAME_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'',
  ORIGIN_FACTORY_EASY_PACKAGE:'',
  OE:'pt_brand_name',
  BRAND:'pp_brand_name',
  CAR_DISASSEMBLY_PART:'',
  DEPUTY_FACTORY:'',
  REMANUFACTURED_PARTS: '',
}

/* 报价的不同品质的品牌简称 */
export const QUOTE_BRAND_ALIAS_NAME_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'',
  ORIGIN_FACTORY_EASY_PACKAGE:'',
  OE:'pt_brand_alias_name',
  BRAND:'pp_brand_alias_name',
  CAR_DISASSEMBLY_PART:'',
  DEPUTY_FACTORY:'',
  REMANUFACTURED_PARTS: '',
}

/* 比价提交选中的品质 */
export const QUALITY_FIRST_LETTER_STRING = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'YBJ',
    ORIGIN_FACTORY_EASY_PACKAGE:'XXJ',
    OE:'PTJ',
    BRAND:'PPJ',
    CAR_DISASSEMBLY_PART:'CCJ',
    DEPUTY_FACTORY:'FCJ',
};
/* 比价提交选中的品质，某种情况某个属性存在多个的 */
export const QUALITY_FIRST_LETTER_STRING2 = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE: [ 'YBJ', 'YCJ'],
  ORIGIN_FACTORY_EASY_PACKAGE: ['XXJ'],
  OE: ['PTJ'],
  BRAND: ['PPJ'],
  CAR_DISASSEMBLY_PART: ['CCJ'],
  DEPUTY_FACTORY: ['FCJ'],
};
export const QUALITY_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE:1,
    ORIGIN_FACTORY_EASY_PACKAGE:2,
    OE:3,
    BRAND:4,
    CAR_DISASSEMBLY_PART:5,
    DEPUTY_FACTORY:7,
};
/** 备注 */
export const PART_QUALITY_REMARK_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE: 'ybremark',
    ORIGIN_FACTORY_EASY_PACKAGE: 'xxremark',
    OE:'ptremark',
    BRAND:'ppremark',
    CAR_DISASSEMBLY_PART:'ccremark',
    DEPUTY_FACTORY:'fcremark',
};
export const QUALITY_CHINESE_NAME={
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'原厂原包',
    ORIGIN_FACTORY_EASY_PACKAGE:'原厂简包',
    OE:'配套(OE)',
    BRAND:'品牌(知名品牌)',
    CAR_DISASSEMBLY_PART:'拆车',
    DEPUTY_FACTORY:'副厂(国产小品牌)',
    /* 再制造件也叫修复件，鑫卡盟暂时没有这个品质 */
}
export const QUALITY_CHINESE_HTML_NAME_RESULT={
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'原厂原包<p style="color: red;font-weight: normal;font-size: 13px;">(4S店货带包装)</p>',
    ORIGIN_FACTORY_EASY_PACKAGE:'原厂简包',
    OE:'配套(OE)',
    BRAND:'品牌(知名品牌)',
    CAR_DISASSEMBLY_PART:'拆车',
    DEPUTY_FACTORY:'副厂(国产小品牌)',
}
/** 厂商 */
export const MANUFACTURER_FOR_STRING_RESULT={
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'yb_cs',
    ORIGIN_FACTORY_EASY_PACKAGE:'xx_cs',
    OE:'pt_cs',
    BRAND:'pp_cs',
    CAR_DISASSEMBLY_PART:'cc_cs',
    DEPUTY_FACTORY: 'fc_cs',
};
/** 各品质价格的字段 */
export const QUALITY_PRICE_FOR_STRING_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'ybprice',
    ORIGIN_FACTORY_EASY_PACKAGE:'xxprice',
    OE:'ptprice',
    BRAND:'ppprice',
    CAR_DISASSEMBLY_PART:'ccprice',
    DEPUTY_FACTORY:'fcprice',
}
/* 比价接口价格字段 */
export const DEALER_QUOTE_FOR_STRING_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'pjsybj',
    ORIGIN_FACTORY_EASY_PACKAGE:'pjsxxj',
    OE:'pjsptj',
    BRAND:'pjsppj',
    CAR_DISASSEMBLY_PART:'pjsccj',
    DEPUTY_FACTORY:'pjsfcj',
}
/** 是否现货 */
export const IS_IT_IN_STOCK_FOR_STRING_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE: 'ybisgoods',
    ORIGIN_FACTORY_EASY_PACKAGE:'xxisgoods',
    OE:'ptisgoods',
    BRAND:'ppisgoods',
    CAR_DISASSEMBLY_PART:'ccisgoods',
    DEPUTY_FACTORY:'fcisgoods',
}

/**
 * 调货时间
 */
export const TRANSFER_TIME_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE: 'yb_transfer_time',
  ORIGIN_FACTORY_EASY_PACKAGE: 'xx_transfer_time',
  OE: 'pt_transfer_time',
  BRAND: 'pp_transfer_time',
  CAR_DISASSEMBLY_PART: 'cc_transfer_time',
  DEPUTY_FACTORY: 'fc_transfer_time',
  REMANUFACTURED_PARTS: 'xf_transfer_time',
}

/**
 * 质保期
 */
export const GUARANTEE_PERIOD_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE: 'yb_guarantee_period',
  ORIGIN_FACTORY_EASY_PACKAGE: 'xx_guarantee_period',
  OE: 'pt_guarantee_period',
  BRAND: 'pp_guarantee_period',
  CAR_DISASSEMBLY_PART: 'cc_guarantee_period',
  DEPUTY_FACTORY: 'fc_guarantee_period',
  REMANUFACTURED_PARTS: 'xf_guarantee_period',
}

export const SUBMIT_TYPE_CODE_IN_QUOTE_PRICE = {
    DONE:'xbwc',
    TEMPORARY_STORAGE: 'zc',
}